import Button from "../../../componentes/button/button";
import CardIndicador from "../Shared/CardIndicador";

export const INPUT_CLASS = "w-full h-9 px-3 text-sm border border-input rounded-lg bg-card outline-none focus:border-primary focus:ring-2 focus:ring-primary/15";

export function Campo({ label, required, children }) {
    return (
        <div className="flex flex-col gap-1.5">
            <label className="text-sm font-medium text-foreground/80">
                {label} {required && <span className="text-destructive">*</span>}
            </label>
            {children}
        </div>
    );
}

/**
 * Casca padrão de "Dashboard de Processo": KPIs → gráficos → filtros (com período sempre
 * obrigatório + Pesquisar) → tabela. Cada processo só configura `kpis`/`graficos`/`filtrosExtras`/
 * `children` (tabela) — layout, espaçamento e cards ficam centralizados aqui para manter os
 * dashboards visualmente idênticos entre si.
 */
export default function DashboardProcessoLayout({
    titulo, onNovaSolicitacao, kpis = [], graficos,
    filtros, onFiltroChange, filtrosExtras, onPesquisar, onLimparFiltros, loading, children,
    compacto = false,
}) {
    // Cards um pouco mais "arejados" no modo compacto (mesma bitola do dashboard de Pagamento
    // Compensadas) — só estética, o botão "Pesquisar"/obrigatoriedade do período não mudam.
    const cardClass = compacto
        ? "bg-card border border-border rounded-xl shadow-card p-5"
        : "bg-card border border-border rounded-lg shadow-card p-4";

    return (
        <main className="px-4 py-6">
            <div className="mx-auto flex flex-col gap-4">
                <div className="flex items-center justify-between flex-wrap gap-3">
                    <h1 className="font-display text-2xl font-bold text-foreground">{titulo}</h1>
                    {onNovaSolicitacao && (
                        <Button variant="blue" label="Nova Solicitação" iconLeft="fa fa-plus" onClick={onNovaSolicitacao} />
                    )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-8 gap-2">
                    {kpis.map((kpi, indice) => (
                        <div className={kpi.colspan}>
                        <CardIndicador key={indice} loading={loading} compacto={compacto} {...kpi} />
                     </div>
                     ))}
                </div>

                {graficos && (
                    <div className="flex flex-col gap-2 lg:grid lg:grid-cols-12">
                        {graficos}
                    </div>
                )}

                <div className={cardClass}>
                    <div className="flex items-center justify-between mb-3">
                        <h2 className="text-sm font-semibold text-foreground">Filtros</h2>
                        <button onClick={onLimparFiltros} className="text-xs text-muted-foreground hover:text-foreground hover:underline">
                            Limpar filtros
                        </button>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                        <Campo label="Data Inicial" required>
                            <input
                                type="date"
                                value={filtros.dataInicial ?? ""}
                                onChange={e => onFiltroChange("dataInicial", e.target.value)}
                                className={INPUT_CLASS}
                            />
                        </Campo>
                        <Campo label="Data Final" required>
                            <input
                                type="date"
                                value={filtros.dataFinal ?? ""}
                                onChange={e => onFiltroChange("dataFinal", e.target.value)}
                                className={INPUT_CLASS}
                            />
                        </Campo>
                        {filtrosExtras}
                    </div>
                    <div className="flex justify-end mt-3">
                        <Button variant="blue" label="Pesquisar" iconLeft="fa fa-search" loading={loading} onClick={onPesquisar} />
                    </div>
                </div>

                <div className={"bg-white rounded-xl"}>
                    {children}
                </div>
            </div>
        </main>
    );
}
